import { useEffect, useState } from "react";
import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import reqEmpresa from "../../../../services/reqMultiTenant/reqEmpresa";
import { getReturnUpdated } from "../../../../util/libObject";

export const IndexHook = () => {
	const {
		register,
		handleSubmit,
		setValue,
		watch,
		formState: { isSubmitting },
	} = useForm({
		mode: "onSubmit",
		defaultValues: {
            url_logo: "",
            url_background: "",
            id_empresa: 0
        },
	});

	const [loading, setLoading] = useState(true);
    const [isUpdatedImage, setIsUpdatedImage] = useState(false);
    const [isUpdatedBackGround, setIsUpdatedBackGround] = useState(false);

	const url_logo = watch("url_logo");
	const url_background = watch("url_background");
    const id_empresa = watch("id_empresa");

	const fetchEmpresaData = async () => {
		try {
			setLoading(true);
			const response = await reqEmpresa.listID();
			const storeData = getReturnUpdated(response);

			setValue("id_empresa", storeData.id_empresa);
			setValue("url_logo", storeData.url_logo);
			setValue("url_background", storeData.url_background);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "error" });
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchEmpresaData();
	}, []);

	const handleOnSubmit = async (data) => {
		try {
			await reqEmpresa.update(data);
			Notification.showToast({ message: "Imagens salvas com sucesso.", type: "success" });
            setIsUpdatedImage(false);
            setIsUpdatedBackGround(false);
		} catch (error) {
			Notification.showToast({ message: error.message, type: "error" });
		}
	};

	return {
		register,
		handleSubmit,
		setValue,
		isSubmitting,
		loading,
		url_logo,
		url_background,
		id_empresa,
		isUpdatedImage,
		setIsUpdatedImage,
		isUpdatedBackGround,
		setIsUpdatedBackGround,
		handleOnSubmit,
	};
};
